var _title, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgClearNight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "weather-night-clear")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.687,14.934A8.5,8.5,0,0,1,10.125,6.5a8.573,8.573,0,0,1,.28-2.171A1,1,0,0,0,9.314,3.082a10.5,10.5,0,1,0,11.464,13.1,1,1,0,0,0-1.091-1.247ZM10.625,22a8.5,8.5,0,0,1-2.8-16.526.249.249,0,0,1,.332.254q-.028.386-.028.772A10.514,10.514,0,0,0,18,16.982a.249.249,0,0,1,.208.362A8.508,8.508,0,0,1,10.625,22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.445,10.505l-.264-.038a1.508,1.508,0,0,1-1.273-1.273l-.038-.265a.5.5,0,0,0-.99,0l-.038.265a1.508,1.508,0,0,1-1.273,1.273l-.264.038a.5.5,0,0,0,0,.99l.264.038a1.508,1.508,0,0,1,1.273,1.273l.038.265a.5.5,0,0,0,.99,0l.038-.265a1.508,1.508,0,0,1,1.273-1.273l.264-.038a.5.5,0,0,0,0-.99Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.305,4.5l.464.066a3.013,3.013,0,0,1,2.544,2.546l.067.463a.5.5,0,0,0,.99,0l.067-.464a3.013,3.013,0,0,1,2.544-2.545l.464-.066a.5.5,0,0,0,0-.99l-.464-.066A3.013,3.013,0,0,1,17.437.893L17.37.43a.5.5,0,0,0-.99,0l-.067.464a3.013,3.013,0,0,1-2.544,2.545l-.464.066a.5.5,0,0,0,0,.99Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClearNight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clear_night.ea4e7c05.svg";
export { ForwardRef as ReactComponent };